import { IconProps } from 'types/icon.type'

export const ChevronLeftIcon = (props: IconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Chevron left icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4419 4.55806C13.686 4.80214 13.686 5.19786 13.4419 5.44194L8.88388 10L13.4419 14.5581C13.686 14.8021 13.686 15.1979 13.4419 15.4419C13.1979 15.686 12.8021 15.686 12.5581 15.4419L7.55806 10.4419C7.31398 10.1979 7.31398 9.80214 7.55806 9.55806L12.5581 4.55806C12.8021 4.31398 13.1979 4.31398 13.4419 4.55806Z"
        fill="currentColor"
      />
    </svg>
  )
}
